import React from "react";
import { Link } from "react-router-dom";
import "../../css/Header.css";
import HeaderImage from "../../assets/images/No background logo.png";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="main-header">
      <div className="header-logo">
        <div className="header-logo-content"
          onClick={() => navigate("/")}
        >
          <Link to="/">
            <img src={HeaderImage} alt="Foundations Financial Planning Ltd Logo" />
          </Link>
          <div className="content-large header-title">Foundations Financial Planning Ltd</div>
        </div>
      </div>
      <div className="header-nav">
        <Link to="/about" className="nav-items">
          About Us
        </Link>
        <Link to="/services" className="nav-items">
          Services
        </Link>
        <Link to="/contact" className="nav-items">
          Contact Us
        </Link>
        <Link to="/blogs" className="nav-items">
          Blogs
        </Link>
        <Link to="/fees" className="nav-items">
          Fees
        </Link>
      </div>
    </header>
  );
};

export default Header;
